import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./PaymentHistory.css";

class PaymentHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "past", // 'past' or 'future'
      pastPayments: [],
      futurePayments: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    const web_user_id =
      localStorage.getItem("web_user_id") || sessionStorage.getItem("web_user_id");
    if (
      !web_user_id ||
      web_user_id === "null" ||
      web_user_id === "undefined" ||
      String(web_user_id).trim() === ""
    ) {
      window.location.replace("/searchresultmobile");
      return;
    }
    this.fetchPayments();
  }

  fetchPayments = async () => {
    try {
      this.setState({ loading: true, error: null });

      const web_user_id =
        localStorage.getItem("web_user_id") || sessionStorage.getItem("web_user_id");

      if (!web_user_id) {
        this.setState({
          pastPayments: [],
          futurePayments: [],
          loading: false,
          error: "User session not found.",
        });
        return;
      }

      const response = await axios.get(`/bookings_data/${web_user_id}`);
      const data = response?.data?.data;

      if (!data) {
        this.setState({ pastPayments: [], futurePayments: [], loading: false });
        return;
      }

      const backendBookings = Array.isArray(data) ? data : [data];
      const formattedPayments = backendBookings.map((booking) => ({
        id: booking.id || "N/A",
        title: booking.title || "N/A",
        checkin_date: booking.checkin_date || "N/A",
        checkout_date: booking.checkout_date || "N/A",
        booking_date: booking.booking_date || "N/A",
        payment_status: booking.payment_status || "N/A",
        payment_type: booking.payment_type || "N/A",
        total_amount:
          booking.total_amount !== undefined && booking.total_amount !== null
            ? booking.total_amount
            : booking.sales_price || "N/A",
        booking_status: booking.booking_status || "Pending",
      }));

      // Filter Future Payments: booking_status === "Pending" AND payment_status === "Paid"
      const futurePayments = formattedPayments.filter(
        (item) =>
          item.booking_status?.toLowerCase() === "pending" &&
          item.payment_status?.toLowerCase() === "unpaid"
      );

      // Filter Past Payments: booking_status === "Confirmed" AND payment_status === "Unpaid"
      const pastPayments = formattedPayments.filter(
        (item) =>
          item.booking_status?.toLowerCase() === "confirmed" &&
          item.payment_status?.toLowerCase() === "paid"
      );

      this.setState({
        pastPayments,
        futurePayments,
        loading: false,
      });
    } catch (error) {
      console.error("Payments fetch error:", error);
      this.setState({
        pastPayments: [],
        futurePayments: [],
        loading: false,
        error: "Unable to load your payment history.",
      });
    }
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  // =========================================================
  // STATUS CLASSES
  // =========================================================

  getStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "confirmed":
      case "completed":
        return "ph-status confirmed";
      case "cancelled":
      case "canceled":
        return "ph-status cancelled";
      case "pending":
        return "ph-status pending";
      default:
        return "ph-status";
    }
  };

  getPaymentStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "paid":
      case "completed":
        return "ph-pay-status paid";
      case "pending":
        return "ph-pay-status pending";
      case "unpaid":
      case "failed":
        return "ph-pay-status unpaid";
      default:
        return "ph-pay-status";
    }
  };

  // =========================================================
  // FORMATTING
  // =========================================================

  formatDate = (date) => {
    if (!date || date === "N/A") return "N/A";
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return date;
    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  formatPrice = (price) => {
    if (price === null || price === undefined || price === "" || price === "N/A") return "N/A";
    const numericPrice = Number(price);
    if (Number.isNaN(numericPrice)) return price;
    return `৳${numericPrice.toLocaleString("en-BD")}`;
  };

  // =========================================================
  // ICONS
  // =========================================================

  WalletIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M19 7h-1V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3Zm-1 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  HomeIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M3 10.8 12 3l9 7.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 9.5V21h13V9.5M9 21v-6h6v6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );

  CalendarIcon = () => (
    <svg viewBox="0 0 24 24">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M7.5 3v4M16.5 3v4M3.5 9.5h17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );

  RefreshIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M20 11a8 8 0 0 0-14.8-4L3 10" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 5v5h5" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 13a8 8 0 0 0 14.8 4L21 14" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 19v-5h-5" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  AlertIcon = () => (
    <svg viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="20" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <path d="M24 14v12M24 32v2" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
    </svg>
  );

  EmptyIcon = () => (
    <svg viewBox="0 0 80 80">
      <rect x="15" y="20" width="50" height="40" rx="7" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <path d="M15 34h50M27 20v-5M53 20v-5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="40" cy="52" r="6" fill="none" stroke="currentColor" strokeWidth="2.5" />
    </svg>
  );

  // =========================================================
  // DESKTOP TABLE RENDER
  // =========================================================

  renderDesktopTable = (activeList) => {
    return (
      <div className="ph-desktop-wrapper">
        <div className="ph-desktop-scroll">
          <table className="ph-desktop-table">
            <thead>
              <tr>
                <th>Booking</th>
                <th>Property</th>
                <th>Stay Dates</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Payment</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {activeList.map((item) => (
                <tr key={item.id}>
                  {/* BOOKING */}
                  <td>
                    <div className="ph-desktop-id">BKG-{item.id}</div>
                  </td>
                  {/* PROPERTY */}
                  <td>
                    <div className="ph-desktop-property">
                      <div className="ph-desktop-icon">
                        <this.HomeIcon />
                      </div>
                      <div>
                        <div className="ph-desktop-title" title={item.title}>
                          {item.title}
                        </div>
                        <div className="ph-desktop-subtitle">
                          Booked: {this.formatDate(item.booking_date)}
                        </div>
                      </div>
                    </div>
                  </td>
                  {/* STAY */}
                  <td>
                    <div className="ph-desktop-stay">
                      <div>
                        <span>Check-in</span>
                        <strong>{this.formatDate(item.checkin_date)}</strong>
                      </div>
                      <div className="ph-stay-arrow">→</div>
                      <div>
                        <span>Check-out</span>
                        <strong>{this.formatDate(item.checkout_date)}</strong>
                      </div>
                    </div>
                  </td>
                  {/* METHOD */}
                  <td>
                    <div className="ph-desktop-method">
                      {item.payment_type ? item.payment_type.toUpperCase() : "N/A"}
                    </div>
                  </td>
                  {/* AMOUNT */}
                  <td>
                    <div className="ph-desktop-price">{this.formatPrice(item.total_amount)}</div>
                  </td>
                  {/* PAYMENT */}
                  <td>
                    <span className={this.getPaymentStatusClass(item.payment_status)}>
                      {item.payment_status}
                    </span>
                  </td>
                  {/* STATUS */}
                  <td>
                    <span className={this.getStatusClass(item.booking_status)}>
                      <span className="ph-status-dot" />
                      {item.booking_status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // =========================================================
  // MOBILE CARD RENDER
  // =========================================================

  renderMobileCard = (item) => {
    return (
      <article className="ph-mobile-card" key={item.id}>
        <div className="ph-mobile-top">
          <div className="ph-mobile-icon">
            <this.HomeIcon />
          </div>
          <div className="ph-mobile-heading">
            <span className="ph-mobile-label">BOOKING #{item.id}</span>
            <h3 title={item.title} className="ph-mobile-title">
              {item.title}
            </h3>
          </div>
          <span className={this.getStatusClass(item.booking_status)}>
            <span className="ph-status-dot" />
            {item.booking_status}
          </span>
        </div>

        {/* STAY */}
        <div className="ph-mobile-stay">
          <div className="ph-date-col">
            <span>CHECK-IN</span>
            <strong>{this.formatDate(item.checkin_date)}</strong>
          </div>
          <div className="ph-date-arrow">
            <span />
            <b>›</b>
            <span />
          </div>
          <div className="ph-date-col right">
            <span>CHECK-OUT</span>
            <strong>{this.formatDate(item.checkout_date)}</strong>
          </div>
        </div>

        {/* META */}
        <div className="ph-mobile-meta">
          <div className="ph-meta-item">
            <span className="ph-meta-icon">
              <this.CalendarIcon />
            </span>
            <span>
              <small>Booked on</small>
              <strong>{this.formatDate(item.booking_date)}</strong>
            </span>
          </div>
          <div className="ph-meta-item">
            <span className="ph-meta-icon">
              <this.WalletIcon />
            </span>
            <span>
              <small>Method</small>
              <strong>{item.payment_type ? item.payment_type.toUpperCase() : "N/A"}</strong>
            </span>
          </div>
        </div>

        {/* FOOTER */}
        <div className="ph-mobile-footer">
          <div>
            <small>Total amount</small>
            <strong className="ph-mobile-price">{this.formatPrice(item.total_amount)}</strong>
          </div>
          <div className="ph-mobile-payment">
            <small>Payment</small>
            <span className={this.getPaymentStatusClass(item.payment_status)}>
              {item.payment_status}
            </span>
          </div>
        </div>
      </article>
    );
  };

  // =========================================================
  // STATES (LOADING, ERROR, EMPTY)
  // =========================================================

  renderLoading = () => (
    <div className="ph-state-box">
      <div className="ph-spinner" />
      <h3>Loading payments</h3>
      <p>Please wait while we securely retrieve your transaction history.</p>
    </div>
  );

  renderError = () => (
    <div className="ph-state-box error-state">
      <div className="ph-state-icon error-icon">
        <this.AlertIcon />
      </div>
      <h3>Unable to load history</h3>
      <p>{this.state.error}</p>
      <button type="button" className="ph-action-btn" onClick={this.fetchPayments}>
        <this.RefreshIcon />
        Try Again
      </button>
    </div>
  );

  renderEmpty = () => {
    const { activeTab } = this.state;
    return (
      <div className="ph-state-box empty-state">
        <div className="ph-state-icon empty-icon">
          <this.EmptyIcon />
        </div>
        <span className="ph-empty-badge">No records</span>
        <h3>No {activeTab} payments found</h3>
        <p>
          {activeTab === "past"
            ? "You have no past payments matching 'Confirmed & Unpaid' status."
            : "You have no future payments matching 'Pending & Paid' status."}
        </p>
      </div>
    );
  };

  // =========================================================
  // MAIN RENDER
  // =========================================================

  render() {
    const { activeTab, pastPayments, futurePayments, loading, error } = this.state;
    const activeList = activeTab === "past" ? pastPayments : futurePayments;

    return (
      <div className="ph-view-container">
        {/* HEADER */}
        <header className="ph-page-header">
          <div className="ph-header-left">
            <div className="ph-header-icon">
              <this.WalletIcon />
            </div>
            <div>
              <h2 className="ph-title">Payment History</h2>
              <p className="ph-subtitle">Track and manage your past and upcoming transactions.</p>
            </div>
          </div>
          {!loading && !error && (
            <div className="ph-count-badge">
              <strong>{activeList.length}</strong>
              <span>Records</span>
            </div>
          )}
        </header>

        {/* TABS */}
        <div className="ph-tabs-wrapper">
          <button
            type="button"
            className={`ph-tab-btn ${activeTab === "past" ? "active" : ""}`}
            onClick={() => this.handleTabChange("past")}
          >
            PAST PAYMENTS
            <span className="ph-tab-count">{pastPayments.length}</span>
          </button>
          <button
            type="button"
            className={`ph-tab-btn ${activeTab === "future" ? "active" : ""}`}
            onClick={() => this.handleTabChange("future")}
          >
            FUTURE PAYMENTS
            <span className="ph-tab-count">{futurePayments.length}</span>
          </button>
        </div>

        {/* CONTENT */}
        {loading && this.renderLoading()}
        {!loading && error && this.renderError()}
        {!loading && !error && activeList.length === 0 && this.renderEmpty()}
        {!loading && !error && activeList.length > 0 && (
          <>
            <div className="ph-desktop-only">{this.renderDesktopTable(activeList)}</div>
            <div className="ph-mobile-only">{activeList.map(this.renderMobileCard)}</div>
          </>
        )}
      </div>
    );
  }
}

export default PaymentHistory;